import classNames from "classnames";
import * as React from "react";
import { useContext } from "react";
import CellTitle from "../cell/cell-title.js";
import { prefixClassname } from "../styles/index.js";
import FormContext from "./form.context.js";
function FormLabel(props) {
    const { align: alignProp, colon: colonProp, children, className, ...restProps } = props;
    const { colon: ctxColon, labelAlign } = useContext(FormContext);
    const align = alignProp ?? labelAlign;
    const colon = colonProp ?? ctxColon;
    return (React.createElement(CellTitle, { className: classNames(prefixClassname("form-label"), {
            [prefixClassname("form-label--left")]: align === "left",
            [prefixClassname("form-label--center")]: align === "center",
            [prefixClassname("form-label--right")]: align === "right",
        }, className), ...restProps },
        children,
        colon ? ":" : undefined));
}
FormLabel.displayName = "FormLabel";
export default FormLabel;
